/**
 * @file Contains helper functions for the drawer
 */
import { Location } from 'react-router-dom';

import translate from '../../../i18n/translate';
import { getSidebarToggleUrl } from '../../../routes/urls/searchParams/sidebar';

import { CollapsibleItem, NavItem, NavTab } from './types';

/**
 * Array of collapsible item ids
 */
const collapsibleItems: CollapsibleItem[] = [
  'chat',
  'hotels',
  'settings',
  'smartViews',
  'topics',
];

/**
 * Type guard function to check whether the id of item is a CollapsibleItem
 *
 * @param id Id of the item
 * @returns  Whether item is collapsible
 */
export const getIsCollapsibleItem = (id: NavTab): id is CollapsibleItem => {
  return collapsibleItems.includes(id as CollapsibleItem);
};

/**
 * Generates rail list item for hotel change
 *
 * @param hotelName Name of the hotel
 * @param location  Current location
 * @returns         Rail list item for hotel change
 */
export const getRailListItemHotel = (
  hotelName: string,
  location: Location,
): NavItem => ({
  icon: 'apartment',
  id: 'hotels',
  label: hotelName,
  to: getSidebarToggleUrl(location, 'hotels'),
});

/**
 * Generates rail list item for settings
 *
 * @param location Current location
 * @returns        Rail list item for settings
 */
export const getRailListItemSettings = (location: Location): NavItem => ({
  icon: 'settings',
  id: 'settings',
  label: translate('NAVIGATION__SETTINGS'),
  to: getSidebarToggleUrl(location, 'settings'),
});
